import { createFileRoute } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { CalendarPage, calendarBeforeLoad } from '@/pages/calendar';

export const Route = createFileRoute('/calendar')({
    beforeLoad: calendarBeforeLoad,
    component: CalendarPage,
    pendingComponent: LoadingPage,
});
